<template>
  <div id="app">
    <!-- Header -->
    <header class="duik-header">
      <nav class="navbar navbar-dark fixed-top bg-light flex-nowrap p-0">
        <a class="navbar-brand bg-md-primary-darker col-md-3 col-xl-2 mr-0 py-3 bg-light" :href="sub"></a>

        <!-- Header Search -->
        <!--<input class="js-search border-0 d-none d-md-block form-control form-control-sm w-100 ml-md-4" type="text" placeholder="Search..." aria-label="Search..." data-url="/assets/include/json/autocomplete-data-for-documentation-search.json">-->
        <!-- End Header Search -->

        <!-- Header Links -->
        <!-- End Header Links -->
      </nav>
    </header>
    <!-- End Header -->

    <div class="container-fluid">
      <div class="row">
        <!-- Sidebar -->
        <nav class="col-md-3 col-xl-2 bg-light duik-sidebar navbar-expand-md">
          <div class="d-flex d-md-none justify-content-between mb-5">
            <!-- Sidebar Search -->
            <form class="col form-inline input-group-sm">
              <!--<input class="js-search form-control form-control-sm w-100" type="text" placeholder="Search..." data-url="/assets/include/json/autocomplete-data-for-documentation-search.json">-->
            </form>
            <!-- End Sidebar Search -->

            <!-- Responsive Toggle Button -->
            <button class="btn btn-link pl-0" type="button" data-toggle="collapse" data-target="#sidebar-nav" aria-controls="sidebar-nav" aria-expanded="false" aria-label="Toggle navigation">
              <svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 30 30" width="30" height="30" focusable="false">
                <path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" d="M4 7h22M4 15h22M4 23h22"/>
              </svg>
            </button>
            <!-- End Responsive Toggle Button -->
          </div>
          <Menu />
        </nav>
        <!-- End Sidebar -->

        <main class="ml-md-auto col-md-9 col-xl-10 px-4 pt-0 pt-md-11">
          
          <router-view />

          <!-- Footer -->
          <footer class="small py-4">
            <div class="row">
              <!-- Copyright -->
              <div class="col-md-6 text-center text-dark text-md-left mb-3 mb-md-0">
                &copy; {{ new Date().getFullYear() }} FormaCar. All rights reserved. 18+
              </div>
              <!-- End Copyright -->

              <!-- Social Icons -->
              <!--<div class="col-md-6 col-xl-4 align-self-center">
                <ul class="list-inline text-center text-md-right mb-0">
                  <li class="list-inline-item mx-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Github">
                    <a class="text-dark" target="_blank" href="https://github.com/htmlstreamofficial/">
                      <i class="fab fa-github"></i>
                    </a>
                  </li>
                  <li class="list-inline-item mx-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Facebook">
                    <a class="text-dark" target="_blank" href="https://www.facebook.com/htmlstream">
                      <i class="fab fa-facebook"></i>
                    </a>
                  </li>
                  <li class="list-inline-item mx-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Instagram">
                    <a class="text-dark" target="_blank" href="https://www.instagram.com/htmlstream">
                      <i class="fab fa-instagram"></i>
                    </a>
                  </li>
                  <li class="list-inline-item mx-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Twitter">
                    <a class="text-dark" target="_blank" href="https://twitter.com/htmlstream">
                      <i class="fab fa-twitter"></i>
                    </a>
                  </li>
                  <li class="list-inline-item ml-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Dribbble">
                    <a class="text-dark" target="_blank" href="https://dribbble.com/htmlstream">
                      <i class="fab fa-dribbble"></i>
                    </a>
                  </li>
                </ul>
              </div>-->
              <!-- End Social Icons -->
            </div>
          </footer>
          <!-- End Footer -->
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/Menu";

export default {
  components: {
    Menu
  },
  data() {
    return {
      sub: process.env.VUE_APP_PATH_SUB + '/user_agreement/',
    }
  },
  methods: {
  },
  mounted() {
  },
}
</script>

<style lang="scss">
</style>
